import axios from 'axios';
import store from '../store';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/entrepot`;

// Set up request interceptor to attach token
axios.interceptors.request.use(config => {
    const state = store.getState();
    const token = state.token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export const getAllEntrepots = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/getall`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getEntrepotByCode = async (code_ent) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/get/${code_ent}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createEntrepot = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/create`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateEntrepot = async (code_ent, data) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/update/${code_ent}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteEntrepot = async (code_ent) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/delete/${code_ent}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getDefaultEntrepot = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/default`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const setDefaultEntrepot = async (code_ent) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/default`, { code_ent });
        return response.data;
    } catch (error) {
        throw error;
    }
};


